import { createSlice } from "@reduxjs/toolkit";
import {
  startChat,
  getMyChats,
  getCompanyChats,
  sendMessage,
  getChatMessages,
} from "./thunk";

const initialState = {
  chats: [],
  messages: [],
  loading: false,
  error: null,
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.messages = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // ========================
      // START CHAT
      // ========================
      .addCase(startChat.pending, (state) => {
        state.loading = true;
      })
      .addCase(startChat.fulfilled, (state, action) => {
        state.loading = false;
        state.chats.unshift(action.payload);
      })
      .addCase(startChat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========================
      // GET MY CHATS (USER)
      // ========================
      .addCase(getMyChats.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMyChats.fulfilled, (state, action) => {
        state.loading = false;
        state.chats = action.payload;
      })
      .addCase(getMyChats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========================
      // GET COMPANY CHATS (OWNER)
      // ========================
      .addCase(getCompanyChats.fulfilled, (state, action) => {
        state.chats = action.payload;
      })

      // ========================
      // SEND MESSAGE
      // ========================
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.messages.unshift({
          ...action.payload,
          myMessage: true,
        });
      })

      // ========================
      // GET CHAT MESSAGES
      // ========================
      .addCase(getChatMessages.pending, (state) => {
        state.loading = true;
      })
      .addCase(getChatMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload;
      })
      .addCase(getChatMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMessages } = chatSlice.actions;
export default chatSlice.reducer;
